export default __webpack_public_path__ + "static/media/call1Black.26353bcb.svg";